import type { ReactNode } from 'react'
import { formatNumber } from '@/utils/format'
import { cx } from '../cx'
import styles from './SectionHeader.module.css'

export function SectionHeader({
  children,
  as: Tag = 'h2',
  rule = false,
  count,
  trailingSpacing = 'none',
  className,
}: {
  children: ReactNode
  as?: 'h2' | 'h3' | 'p'
  rule?: boolean
  count?: number
  trailingSpacing?: 'none' | 'compact' | 'section'
  className?: string
}) {
  return (
    <Tag
      className={cx(styles.sectionHeader, className)}
      data-trailing={trailingSpacing}
    >
      <span className={styles.label}>{children}</span>
      {count != null && (
        <>
          {/* Whitespace-only text is not rendered in the flex row, but it
              keeps the accessible name "Workspace-scoped 6". */}{' '}
          <span className={styles.count}>{formatNumber(count)}</span>
        </>
      )}
      {rule && <span className={styles.rule} aria-hidden="true" />}
    </Tag>
  )
}
